import {
  Component, ComponentFactoryResolver,
  ViewContainerRef, ViewChild, OnInit
} from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-component-container-modal',
  templateUrl: './component-container-modal.component.html',
  styleUrls: ['./component-container-modal.component.scss']
})
export class ComponentContainerModalComponent implements OnInit {
  title: string;
  description: string;
  hasOkBtn: boolean = true;

  @ViewChild("container", { read: ViewContainerRef, static: true }) container;
  componentRef: any;
  component: any
  initialData: any = [];
  componentConfig: any;
  row: any;
  hasCloseBtn: boolean;
  closeBtnLabel: string;

  constructor(private resolver: ComponentFactoryResolver, public modalRef: BsModalRef) { }

  createComponent() {
    this.container.clear();
    const factory: any = this.resolver.resolveComponentFactory(this.component);
    
    this.componentRef = this.container.createComponent(factory);

    this.componentRef.instance.onDecline = this.onDecline.bind(this);
    if(this.initialData){
      this.componentRef.instance.initialData = this.initialData;
    }
    if(this.componentConfig){
      this.componentRef.instance.config = this.componentConfig;
    }
    if(this.row){
      this.componentRef.instance.row = this.row;
    }

  }

  ngOnInit() {
    this.createComponent();
  }

  ngOnDestroy() {
    this.componentRef.destroy();
  }

  onDecline() {
    this.modalRef.hide()
  }

}



